'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteCanvassingRegion = exports.updateCanvassingRegion = exports.createCanvassingRegion = exports.fetchCanvassingRegion = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _callApi = require('./callApi');

var _callApi2 = _interopRequireDefault(_callApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchCanvassingRegion = exports.fetchCanvassingRegion = function fetchCanvassingRegion(options) {
  return (0, _callApi2.default)('POST', '/canvassing-region/find', _extends({}, options), 'application/json');
};
var createCanvassingRegion = exports.createCanvassingRegion = function createCanvassingRegion(region) {
  return (0, _callApi2.default)('POST', '/canvassing-region', _extends({}, region), 'application/json');
};
var updateCanvassingRegion = exports.updateCanvassingRegion = function updateCanvassingRegion(region) {
  return (0, _callApi2.default)('PUT', '/canvassing-region', _extends({}, region), 'application/json');
};
var deleteCanvassingRegion = exports.deleteCanvassingRegion = function deleteCanvassingRegion(_id) {
  return (0, _callApi2.default)('DELETE', '/canvassing-region', { _id: _id }, 'application/json');
};


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/canvassing-region.js
// module id = 723
// module chunks = 0